import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import bowser from 'yola-bowser';
import { Tour, TourDialog } from '@yola/ws-ui';
import { integration, i18next, dialogs } from '@yola/ws-sdk';
import { useSelector, useDispatch } from 'react-redux';
import segment from '../../analytics/segment';
import constants from '../constants';
import helpers from '../helpers';

const {
  trackers: { trackEvent },
  constants: { events },
} = segment;

function WelcomeTourContainer({ onDialogMainAction, onDialogCancel }) {
  const dispatch = useDispatch();

  const {
    updateUserPreference,
    userPreferences: { welcomeTourCompleted },
  } = useSelector(integration.selectors.getSettings);

  const setWelcomeTourCompleted = useCallback(() => {
    if (welcomeTourCompleted) {
      return;
    }
    const property = constants.common.WELCOME_TOUR_COMPLETED;
    const value = true;

    const properties = {
      [integration.constants.SYMBOL_SETTING]: {
        disableBlocking: true,
      },
      property,
      value,
    };
    if (!updateUserPreference) return;
    updateUserPreference({ properties });
  }, [welcomeTourCompleted, updateUserPreference]);

  const handleCloseDialog = useCallback(
    (step) => {
      if (!welcomeTourCompleted) {
        trackEvent(events.WELCOME_TOUR_SKIPPED, {
          step: step + 1,
        });
      }

      onDialogCancel();
      setWelcomeTourCompleted();
      dispatch(dialogs.actions.hide());
    },
    [welcomeTourCompleted, setWelcomeTourCompleted, onDialogCancel, dispatch]
  );

  const handleFinishTour = useCallback(() => {
    if (!welcomeTourCompleted) {
      trackEvent(events.WELCOME_TOUR_COMPLETED);
    }
    setWelcomeTourCompleted();
    onDialogMainAction();
    dispatch(dialogs.actions.hide());
  }, [welcomeTourCompleted, setWelcomeTourCompleted, onDialogMainAction, dispatch]);

  const items = helpers.getItems(constants.tours.WELCOME_TOUR);

  const isMobile = bowser.mobile;
  return (
    <TourDialog>
      <Tour
        className="ws-welcome-tour"
        handleCloseDialog={handleCloseDialog}
        handleFinishTour={handleFinishTour}
        showPrevButton={!isMobile}
        showNextButton={!isMobile}
        showFinishButton={!isMobile}
        items={items}
        captions={{
          buttons: {
            skip: i18next.t('Skip'),
            next: i18next.t('Next'),
            back: i18next.t('Back'),
            finish: i18next.t('Start editing'),
          },
        }}
      />
    </TourDialog>
  );
}

WelcomeTourContainer.propTypes = {
  onDialogMainAction: PropTypes.func.isRequired,
  onDialogCancel: PropTypes.func.isRequired,
};

export default WelcomeTourContainer;
